// ADV-799: Today page greeting. Pure function exported as a hook for symmetry
// with the surrounding feature module — the "current time" read is intentional
// at render time, not memoized, so a page that stays open across hours
// re-greets on the next render.

export function useGreeting(displayName: string | undefined | null): string {
  const hour = new Date().getHours();
  const part = hour < 12 ? "morning" : hour < 18 ? "afternoon" : "evening";
  const firstName = displayName?.trim().split(/\s+/)[0];
  const who = firstName && firstName.length > 0 ? firstName : "there";
  return `Good ${part}, ${who}`;
}
